(() => {
  const rootPath = window.Shopify?.routes?.root || '/';
  const root = document.querySelector('[data-findtag-root]');
  if (!root) return;
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: window.Shopify?.currency?.active || 'AUD' }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const truthy = (value) => value === 'true';
  const live = document.querySelector('[data-live-region]');
  const announce = (message) => { if (live) live.textContent = message; };

  const offerCountdown = document.querySelector('[data-offer-countdown]');
  const updateOfferCountdown = () => {
    if (!offerCountdown) return;
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setHours(24, 0, 0, 0);
    const remaining = Math.max(0, tomorrow.getTime() - now.getTime());
    const totalSeconds = Math.floor(remaining / 1000);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    offerCountdown.textContent = `${hours}:${minutes}:${seconds}`;
  };
  updateOfferCountdown();
  const offerTimer = window.setInterval(updateOfferCountdown, 1000);


  const variants = {
    card: { id: root.dataset.cardVariantId, available: truthy(root.dataset.cardAvailable) },
    pet: { id: root.dataset.petVariantId, available: truthy(root.dataset.petAvailable) },
  };
  const bundleButtons = [...document.querySelectorAll('[data-bundle]')];
  const initialBundleId = root.dataset.pageProduct === 'pet-findtag'
    ? 'pet-single'
    : root.dataset.pageProduct === 'card-findtag'
      ? 'card-single'
      : 'card-single';
  let selected = bundleButtons.find((button) => button.dataset.bundleId === initialBundleId) || bundleButtons[0];
  let selectionQuantity = 1;

  const selectionVariant = () => variants[selected?.dataset.variantKey || ''];
  const selectionAvailable = () => Boolean(selectionVariant()?.id) && selectionVariant().available;
  const updateSelection = () => {
    if (!selected) return;
    bundleButtons.forEach((button) => {
      const active = button === selected;
      button.classList.toggle('bundle-card-selected', active);
      button.toggleAttribute('data-selected', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const price = Number(selected.dataset.priceCents || 0) * selectionQuantity;
    const regular = Number(selected.dataset.regularCents || 0) * selectionQuantity;
    const savings = Math.max(0, regular - price);
    document.querySelectorAll('[data-selection-quantity]').forEach((node) => { node.textContent = String(selectionQuantity); });
    document.querySelectorAll('[data-selection-total]').forEach((node) => { node.textContent = money(price); });
    document.querySelectorAll('[data-add-selection-label]').forEach((node) => { node.textContent = `Add ${selectionQuantity > 1 ? `${selectionQuantity} × ` : ''}${selected.dataset.bundleTitle}`; });
    document.querySelectorAll('[data-mobile-selection-summary]').forEach((node) => { node.innerHTML = `${escapeHtml(selected.dataset.bundleTitle)} ${money(Number(selected.dataset.priceCents || 0))}${savings ? ` <span class="text-[10px] font-extrabold text-emerald-600">· Save ${money(savings)}</span>` : ''}`; });
    const share = document.querySelector('[data-product-share]');
    if (share) {
      const handle = selected.dataset.bundleId === 'pet-single' ? 'pet-findtag' : 'card-findtag';
      const url = `https://findtag.store/products/${handle}`;
      const title = selected.dataset.bundleTitle || 'FindTag';
      share.dataset.shareUrl = url;
      share.dataset.shareTitle = title;
      share.setAttribute('aria-label', `Share ${title}`);
      const encodedUrl = encodeURIComponent(url);
      const encodedText = encodeURIComponent(`Check out ${title} from FindTag`);
      share.querySelector('[data-share-title-text]').textContent = title;
      share.querySelector('[data-share-facebook]').setAttribute('href', `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`);
      share.querySelector('[data-share-whatsapp]').setAttribute('href', `https://wa.me/?text=${encodedText}%20${encodedUrl}`);
      share.querySelector('[data-share-x]').setAttribute('href', `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`);
      share.querySelector('[data-share-email]').setAttribute('href', `mailto:?subject=${encodedText}&body=${encodedUrl}`);
    }
    document.querySelectorAll('[data-add-selection]').forEach((button) => {
      button.disabled = !selectionAvailable();
      button.classList.toggle('shopify-disabled', !selectionAvailable());
      button.setAttribute('aria-disabled', String(!selectionAvailable()));
      button.title = selectionAvailable() ? '' : 'Connect this product in the Shopify theme editor.';
    });
  };
  if (!selectionAvailable()) {
    selected = bundleButtons.find((button) => { const variant = variants[button.dataset.variantKey || '']; return Boolean(variant?.id) && variant.available; }) || selected;
  }
  const petQuickAdd = document.querySelector('[data-quick-add-pet]');
  if (petQuickAdd && (!variants.pet.id || !variants.pet.available)) { petQuickAdd.hidden = true; petQuickAdd.disabled = true; petQuickAdd.classList.add('shopify-disabled'); petQuickAdd.title = 'Pet FindTag is not currently available in Shopify.'; }

  // Delegate product selection so taps on nested text and icons remain reliable on mobile Safari.
  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bundle]');
    if (!button || !root.contains(button)) return;
    selected = button;
    selectionQuantity = 1;
    updateSelection();
  });
  document.querySelectorAll('[data-select-bundle]').forEach((link) => link.addEventListener('click', () => {
    const match = bundleButtons.find((button) => button.dataset.bundleId === link.dataset.selectBundle);
    if (match) { selected = match; selectionQuantity = 1; updateSelection(); }
  }));
  document.querySelectorAll('[data-selection-minus]').forEach((button) => button.addEventListener('click', () => { selectionQuantity = Math.max(1, selectionQuantity - 1); updateSelection(); }));
  document.querySelectorAll('[data-selection-plus]').forEach((button) => button.addEventListener('click', () => { selectionQuantity = Math.min(10, selectionQuantity + 1); updateSelection(); }));

  const shell = document.querySelector('[data-cart-shell]');
  const lines = document.querySelector('[data-cart-lines]');
  const footer = document.querySelector('[data-cart-footer]');
  const termsCheckbox = document.querySelector('[data-terms-checkbox]');
  const termsError = document.querySelector('[data-terms-error]');
  let termsAccepted = false;
  const openCart = async () => { termsAccepted = false; if (termsCheckbox) termsCheckbox.checked = false; if (termsError) { termsError.classList.add('hidden'); termsError.classList.remove('flex'); } shell.hidden = false; document.body.style.overflow = 'hidden'; await loadCart(); shell.querySelector('[data-cart-close]')?.focus(); };
  const closeCart = () => { shell.hidden = true; document.body.style.overflow = ''; };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  termsCheckbox?.addEventListener('change', () => { termsAccepted = termsCheckbox.checked; if (termsAccepted) { termsError?.classList.add('hidden'); termsError?.classList.remove('flex'); } });
  document.querySelector('[data-checkout-link]')?.addEventListener('click', (event) => { if (termsAccepted) return; event.preventDefault(); if (termsError) { termsError.classList.remove('hidden'); termsError.classList.add('flex'); } termsCheckbox?.focus(); announce('Please tick the Terms and Conditions box before checkout.'); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !shell.hidden) closeCart(); });

  async function addVariant(variant, quantity) {
    if (!variant?.id || !variant.available) throw new Error('This product is not available yet. Connect it in the Shopify theme editor after CJ mapping is complete.');
    const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant.id), quantity, properties: { '_findtag_product': selected?.dataset.bundleTitle || 'FindTag', '_findtag_regular_total_cents': selected?.dataset.regularCents || selected?.dataset.priceCents || '0' } }] }) });
    if (!response.ok) { const body = await response.json().catch(() => ({})); throw new Error(body.description || 'Unable to add this item.'); }
  }
  async function addSelection() {
    try {
      await addVariant(selectionVariant(), selectionQuantity);
      announce(`${selected.dataset.bundleTitle} added to cart.`);
      await openCart();
    } catch (error) { announce(error.message); window.alert(error.message); }
  }
  document.querySelectorAll('[data-add-selection]').forEach((button) => button.addEventListener('click', addSelection));
  document.querySelector('[data-share-copy]')?.addEventListener('click', async (event) => {
    const share = document.querySelector('[data-product-share]');
    const url = share?.dataset.shareUrl || 'https://findtag.store';
    await navigator.clipboard?.writeText(url);
    event.currentTarget.textContent = '✓ Copied';
    announce('Product link copied.');
    window.setTimeout(() => { event.currentTarget.textContent = '↗ Copy link'; }, 1800);
  });
  const cardQuickAdd = document.querySelector('[data-quick-add-card]');
  if (cardQuickAdd && (!variants.card.id || !variants.card.available)) { cardQuickAdd.disabled = true; cardQuickAdd.classList.add('shopify-disabled'); cardQuickAdd.title = 'Card FindTag is not currently available in Shopify.'; }
  cardQuickAdd?.addEventListener('click', async () => {
    const match = bundleButtons.find((button) => button.dataset.bundleId === 'card-single');
    if (match) { selected = match; selectionQuantity = 1; updateSelection(); }
    shell.hidden = false;
    document.body.style.overflow = 'hidden';
    if (lines) lines.innerHTML = '<p class="shopify-cart-note">Adding Card Essential…</p>';
    cardQuickAdd.disabled = true;
    try {
      await addVariant(selectionVariant(), 1);
      announce('Card Essential added to cart.');
      if (lines) lines.innerHTML = '<div class="rounded-2xl bg-[#eef6ff] p-6"><p class="font-display text-xl font-bold text-[#071a3d]">Card Essential added.</p><p class="mt-2 text-sm text-slate-500">Your card is in the cart. Loading the complete order summary…</p></div>';
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(Number(node.textContent || 0) + 1); });
      loadCart(false).then(() => shell.querySelector('[data-cart-close]')?.focus()).catch(() => {});
      shell.querySelector('[data-cart-close]')?.focus();
    } catch (error) {
      announce(error.message);
      if (lines) lines.innerHTML = `<p class="shopify-cart-note">${escapeHtml(error.message)}</p>`;
    } finally {
      cardQuickAdd.disabled = !selectionAvailable();
    }
  });
  document.querySelector('[data-quick-add-pet]')?.addEventListener('click', async () => {
    const match = bundleButtons.find((button) => button.dataset.bundleId === 'pet-single');
    if (match) { selected = match; selectionQuantity = 1; updateSelection(); }
    await addSelection();
  });

  const quickChat = document.querySelector('[data-quick-chat]');
  const quickChatPanel = quickChat?.querySelector('[data-quick-chat-panel]');
  const quickChatToggle = quickChat?.querySelector('[data-quick-chat-toggle]');
  const quickChatReply = quickChat?.querySelector('[data-quick-chat-reply]');
  const closeQuickChat = () => {
    if (!quickChatPanel || !quickChatToggle) return;
    quickChatPanel.hidden = true;
    quickChatToggle.setAttribute('aria-expanded', 'false');
    quickChatToggle.setAttribute('aria-label', 'Open quick chat');
  };
  quickChatToggle?.addEventListener('click', () => {
    if (!quickChatPanel || !quickChatToggle) return;
    const open = quickChatPanel.hidden;
    quickChatPanel.hidden = !open;
    quickChatToggle.setAttribute('aria-expanded', String(open));
    quickChatToggle.setAttribute('aria-label', open ? 'Close quick chat' : 'Open quick chat');
    if (open) quickChat?.querySelector('[data-quick-chat-option]')?.focus();
  });
  quickChat?.querySelector('[data-quick-chat-close]')?.addEventListener('click', closeQuickChat);
  quickChat?.querySelectorAll('[data-quick-chat-option]').forEach((button) => button.addEventListener('click', () => {
    if (quickChatReply) quickChatReply.textContent = button.dataset.quickChatOption || '';
  }));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeQuickChat(); });

  async function loadCart(showLoading = true) {
    if (showLoading && lines) lines.innerHTML = '<p class="shopify-cart-note">Loading cart…</p>';
    const response = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart.');
    renderCart(await response.json());
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(cart.item_count); });
    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    const regularTotal = cart.items.reduce((sum, item) => { const perBundle = Number(item.properties?._findtag_regular_total_cents || 0); return sum + (perBundle > 0 ? perBundle * item.quantity : item.final_line_price); }, 0);
    const savings = Math.max(0, regularTotal - cart.total_price);
    const savingsBox = document.querySelector('[data-cart-savings-message]');
    if (savingsBox) savingsBox.hidden = savings <= 0;
    const savingsValue = document.querySelector('[data-cart-savings]');
    if (savingsValue) savingsValue.textContent = money(savings);
    const regularValue = document.querySelector('[data-cart-regular]');
    if (regularValue) regularValue.textContent = money(regularTotal);
    if (footer) footer.hidden = cart.item_count === 0;
    if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="rounded-2xl bg-[#eef6ff] p-6 text-center"><p class="font-display text-xl font-bold">Your cart is empty.</p><p class="mt-2 text-sm text-slate-500">Choose a FindTag product to get started.</p></div>';
      return;
    }
    lines.innerHTML = cart.items.map((item) => `<article class="shopify-cart-line" data-line-key="${escapeHtml(item.key)}">${item.image ? `<img src="${escapeHtml(item.image)}&width=160" alt="${escapeHtml(item.product_title)}">` : '<span></span>'}<div><div class="shopify-cart-line__head"><div><p class="shopify-cart-line__title">${escapeHtml(item.product_title)}</p>${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="shopify-cart-line__variant">${escapeHtml(item.variant_title)}</p>` : ''}</div><strong>${money(item.final_line_price)}</strong></div><div class="shopify-cart-line__actions"><div class="shopify-cart-qty"><button type="button" data-cart-minus aria-label="Decrease">−</button><input value="${item.quantity}" inputmode="numeric" aria-label="Quantity" data-cart-qty><button type="button" data-cart-plus aria-label="Increase">+</button></div><button class="shopify-cart-remove" type="button" data-cart-remove>Remove</button></div></div></article>`).join('');
    bindCartLines();
  }
  async function changeLine(key, quantity) {
    const response = await fetch(`${rootPath}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!response.ok) throw new Error('Unable to update cart.');
    renderCart(await response.json());
  }
  function bindCartLines() {
    lines?.querySelectorAll('[data-line-key]').forEach((line) => {
      const key = line.dataset.lineKey;
      const input = line.querySelector('[data-cart-qty]');
      line.querySelector('[data-cart-minus]')?.addEventListener('click', () => changeLine(key, Math.max(0, Number(input.value || 1) - 1)));
      line.querySelector('[data-cart-plus]')?.addEventListener('click', () => changeLine(key, Number(input.value || 1) + 1));
      line.querySelector('[data-cart-remove]')?.addEventListener('click', () => changeLine(key, 0));
      input?.addEventListener('change', () => changeLine(key, Math.max(0, Number(input.value || 0))));
    });
  }

  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  menuButton?.addEventListener('click', () => { const open = mobileNav.hasAttribute('hidden'); mobileNav.toggleAttribute('hidden', !open); menuButton.setAttribute('aria-expanded', String(open)); });
  mobileNav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { mobileNav.hidden = true; menuButton?.setAttribute('aria-expanded', 'false'); }));
  const heroVideo = document.querySelector('[data-hero-video]');
  const heroSound = document.querySelector('[data-hero-sound]');
  heroSound?.addEventListener('click', async () => {
    if (!heroVideo) return;
    heroVideo.muted = !heroVideo.muted;
    if (!heroVideo.muted) {
      heroVideo.currentTime = 0;
      await heroVideo.play().catch(() => { heroVideo.muted = true; heroVideo.play().catch(() => {}); });
    }
    heroSound.setAttribute('aria-label', heroVideo.muted ? 'Play Card FindTag hero video with sound' : 'Mute Card FindTag hero video');
    heroSound.setAttribute('title', heroVideo.muted ? 'Hear video' : 'Mute');
  });
  heroVideo?.addEventListener('click', () => heroSound?.click());

  const cardVideo = document.querySelector('[data-card-video]');
  const cardSound = document.querySelector('[data-card-sound]');
  cardSound?.addEventListener('click', async () => {
    if (!cardVideo) return;
    cardVideo.muted = !cardVideo.muted;
    if (!cardVideo.muted) {
      cardVideo.currentTime = 0;
      await cardVideo.play().catch(() => { cardVideo.muted = true; cardVideo.play().catch(() => {}); });
    }
    cardSound.setAttribute('aria-label', cardVideo.muted ? 'Play Card FindTag digital animation with sound' : 'Mute Card FindTag digital animation');
    cardSound.setAttribute('title', cardVideo.muted ? 'Hear animation' : 'Mute');
  });
  cardVideo?.addEventListener('click', () => cardSound?.click());

  const dogVideo = document.querySelector('[data-dog-video]');
  const dogSound = document.querySelector('[data-dog-sound]');
  dogSound?.addEventListener('click', async () => { dogVideo.muted = !dogVideo.muted; if (!dogVideo.muted) { dogVideo.currentTime = 0; await dogVideo.play().catch(() => { dogVideo.muted = true; }); } dogSound.setAttribute('aria-label', dogVideo.muted ? 'Play Pet FindTag dog video with sound' : 'Mute Pet FindTag dog video'); });
  dogVideo?.addEventListener('click', () => dogSound?.click());

  const demo = document.querySelector('[data-demo-video]');
  const demoEnd = document.querySelector('[data-demo-end-cta]');
  const subscribeModal = document.querySelector('[data-subscribe-modal]');
  const openSubscribe = () => { if (!subscribeModal) return; subscribeModal.classList.remove('hidden'); subscribeModal.classList.add('grid'); document.body.style.overflow = 'hidden'; subscribeModal.querySelector('input[type="email"]')?.focus(); };
  const closeSubscribe = () => { if (!subscribeModal) return; subscribeModal.classList.add('hidden'); subscribeModal.classList.remove('grid'); document.body.style.overflow = ''; };
  document.querySelectorAll('[data-subscribe-open]').forEach((button) => button.addEventListener('click', openSubscribe));
  subscribeModal?.querySelector('[data-subscribe-close]')?.addEventListener('click', closeSubscribe);
  subscribeModal?.querySelector('[data-subscribe-backdrop]')?.addEventListener('click', closeSubscribe);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSubscribe(); });
  demo?.addEventListener('play', () => demoEnd?.classList.remove('demo-end-cta-visible'));
  demo?.addEventListener('ended', () => demoEnd?.classList.add('demo-end-cta-visible'));
  demo?.addEventListener('loadedmetadata', () => { if (demo.textTracks?.[0]) demo.textTracks[0].mode = 'showing'; });

  updateSelection();
  loadCart().catch(() => {});
})();
